import { isFinanceOnlyUser, canOpenFinanceRoute } from "./financeAccess";

const BLOCKED_SUBSCRIPTION_STATUSES = new Set([
  "cancelled",
  "canceled",
  "suspended",
  "revoked",
]);

function normalizeStatus(value) {
  return String(value || "").trim().toLowerCase();
}

export function hasApprovedAccountAccess(userData = {}) {
  return (
    userData.accessApproved === true ||
    userData.accessStatus === "approved" ||
    userData.role === "owner" ||
    userData.role === "admin"
  );
}

export function needsSubscriptionSelection(userData = {}) {
  if (!hasApprovedAccountAccess(userData)) return true;
  return BLOCKED_SUBSCRIPTION_STATUSES.has(
    normalizeStatus(userData.subscriptionStatus)
  );
}

export function getPostAuthRoute(userData = {}, returnTo = "/") {
  const isClient =
    userData.role === "client" &&
    Boolean(userData.companyId) &&
    Boolean(userData.clientId);

  const isPortalRequest = /^\/client(?:\/|$)/.test(returnTo.split(/[?#]/)[0]);
  if (isPortalRequest && !isFinanceOnlyUser(userData)) return returnTo;
  if (hasApprovedAccountAccess(userData) && isClient) return "/client";
  if (needsSubscriptionSelection(userData)) return "/pricing";
  if (isFinanceOnlyUser(userData) && !canOpenFinanceRoute(returnTo.split(/[?#]/)[0])) return "/finance";
  return returnTo;
}
